import { Component } from '@angular/core';
import { StatusButtons } from '../../../_shared/interfaces';
import { ProjectsOverviewComponent } from "./projects-overview/projects-overview.component";
import { NgForOf } from "@angular/common";

@Component({
  selector: 'app-projects',
  standalone: true,
  imports: [
    ProjectsOverviewComponent,
    NgForOf
  ],
  templateUrl: './projects.component.html',
  styleUrl: './projects.component.sass'
})
export class ProjectsComponent {
  status: string = 'all';

  statusButtons: StatusButtons[] = [
    { state: 'all', display: 'Alle', label: 'alert-danger', icon: 'info-circle'},
    { state: 'open', display: 'Offen', label: 'alert-info', icon: 'info-circle'},
    { state: 'running', display: 'In Arbeit', label: 'alert-warning', icon: 'info-circle'},
    { state: 'requested', display: 'Projekt', label: 'alert-info', icon: 'info-circle'},
    { state: 'confirmed', display: 'Auftrag', label: 'alert-info', icon: 'info-circle'},
    { state: 'lost', display: 'Verloren', label: 'alert-danger', icon: 'check-circle'},
    { state: 'invoiced', display: 'Berechnet', label: 'alert-danger', icon: 'check-circle'},
    { state: 'finished', display: 'Erledigt', label: 'alert-success', icon: 'info-circle'}
  ];

  changeOverviewStatus(status: string){
    this.status = status;
  }

}
